import { useMutate, UseMutateParams } from './useMutate';
import { httpDelete } from '../../components/utils';
import { useCallback } from 'react';

export type UseDeleteParams<TResponse = unknown, TError = unknown> = Omit<
    UseMutateParams<never, TResponse, TError>,
    'method'
>;

export const useDelete = <TResponse = unknown, TError = unknown>(params: UseDeleteParams<TResponse, TError>) => {
    // @ts-ignore TODO: currently can't use the generics in `httpDelete`, need to be removed when `httpDelete` will support generics
    const { mutate, loading, error } = useMutate<never, TResponse, TError>({ ...params, method: httpDelete });

    const deleteMethod = useCallback((url: string) => mutate(url), [mutate]);

    return {
        loading,
        error,
        deleteMethod
    };
};
